var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-container"},[_c('div',{attrs:{"v-if":_vm.errorMsg}},[_vm._v(_vm._s(_vm.errorMsg))]),_vm._v(" "),_c(_vm.loadedComponent,{tag:"component",staticClass:"tab"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c6664e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tests/pages/VueTestsPage.vue
// module id = null
// module chunks = 